<template>
	<div class="ReChatSidebar">
        <div class="sideChat_header">
            <div class="chat_logo">
                <i class="tim-icons icon-send text-primary mr-3"></i>
                <div class="logoTxt-img logo-txt-onl"></div>
            </div>
            <div class="chat_nav">
                <base-dropdown title-classes="btn btn-icon btn-simple btn-primary no-border">
                    <template v-slot:title>
                        <i class="d-inline-block tim-ic ic-menudot"></i>
                    </template>

                    <a class="dropdown-item">Отключить все уведомления</a>
                    <a class="dropdown-item">Открыть закладки</a>
                    <!--появляется для тех, у кого есть права на редактирование канала-->
                </base-dropdown>

                <base-button type="primary" class="no-border" simple icon>
                    <i class="d-inline-block tim-ic ic-fullscreen"></i>
                </base-button>
                <base-button type="primary" class="no-border" simple icon>
                    <i class="d-inline-block tim-icons icon-simple-remove"></i>
                </base-button>

            </div>
        </div>
        <div class="chat_body">
            <div class="d-flex mb-3">
                <el-select
					class="col-md select-primary chatSrch"
                    v-model="value" filterable placeholder="Найти"
					size="large"
				>
					<el-option
						class="select-primary"
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
					>
					</el-option>
				</el-select>

                <button class="btn btn-icon btn-simple btn-primary">
                    <i class="tim-icons icon-simple-add"></i>
                </button>
            </div>
            <div class="all_chats">
                <ReChatSmall/>
                <ReChatSmall/>
                <ReChatSmall/>
                <ReChatSmall/>
                <ReChatSmall/>
                <ReChatSmall/>
            </div>
        </div>
	</div>
</template>

<script>
import { Select, Option } from 'element-ui';
import ReChatSmall from "src/our_components/ReChatSmall.vue";


export default {
    name: 'ReChatSidebar',
    components: {
        [Option.name]: Option,
        [Select.name]: Select,
        ReChatSmall,
    },
    props: {
        counter: String,
        findId: {
            type: String,
            default: '',
        },            
    },
    data () {
        return {
            ver: 1,
             options: [{
                value: 'Канал 1',
                label: 'Канал 1'
                }, {
                value: 'Канал 2',
                label: 'Канал 2'
                }, {
                value: 'Канал 3',
                label: 'Канал 3'
                }, {
                value: 'Канал 4',
                label: 'Канал 4'
                }, {
                value: 'Канал 5',
                label: 'Канал 5'
                }],
            value: '',   
            whiteLogo: true,           
        }      
    },
    computed: {

    },
    methods: {

    },
}
</script>
<style scoped>
.ReChatSidebar {display: block;}
.sideChat_header {display: flex; flex-direction: row; justify-content: space-between; margin-bottom: 10px;} 
.chat_body, .all_chats {display: flex; flex-direction: column;}
.logoTxt-img  img {
    height: 30px;
}
.chat_logo, .chat_nav  {display: flex; align-items: center;} 
.chat_nav .btn, .chat_body .btn {margin-top: 0;}
.ReChatSidebar  .chatSrch {
    padding-left: 0;
}
.active, .ReChatSmall:hover {
    background-color: rgba(1, 176, 224, 0.25);
    cursor: pointer;
}
.ReChatSidebar >>> .dropdown-menu {
  right: 0 !important;
  top: 90% !important;
  left: auto !important;
}
.ReChatSidebar >>> .dropdown-menu::before {
  right: 10px !important;
  left: auto !important;
}

.ReChatSidebar .el-select .el-input.is-focus .el-input__inner {border-color: #01B0E0;}

.logo-txt-onl {background-size: contain; height: 30px; width: 70px;}
.logo-txt-onl {background: url('/img/icons/Logo_reactor_txt_only_W.svg') center no-repeat;}
.white-content .logo-txt-onl {background: url('/img/icons/Logo_reactor_txt_only_B.svg') center no-repeat;}

</style>
